import {css, Theme} from "@emotion/react";

import {display} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {investmentOffer, numberFormat, propertyOffer} from "@pg-mono/string-utils";

import {ILatestQuery} from "../../../../utils/latest_query";
import {ListMainHeader} from "../../../atoms/ListMainHeader";
import {OfferAveragePrice} from "../OfferAveragePrice/OfferAveragePrice";
import {OfferListPromotionLink} from "../OfferListPromotionLink";
import {OfferListHeaderProps} from "./OfferListHeader";

interface IProps extends OfferListHeaderProps {
    onHeaderClick?: () => void;
}

export const OfferListHeaderText = (props: IProps) => {
    const promotionsCount = props.selectedRegion.length === 1 ? props.selectedRegion[0].stats?.promotions_count_total : 0;
    const hidePromotions = isAnyFilterInUse(props.latestQuery);
    // Minimum promotions number needed to display link - business requirement
    const isLessPromotionsThenOffers = !!props.propertiesCount && !!promotionsCount && props.propertiesCount < promotionsCount;
    const showPromotionsLink = !!promotionsCount && promotionsCount > 5 && !isLessPromotionsThenOffers && !hidePromotions;
    const singleRegion = !!props.selectedRegion.length ? props.selectedRegion[props.selectedRegion.length - 1] : undefined;
    const hasRegionAveragePrice = singleRegion?.stats?.average_price_m2;

    return (
        <>
            <ListMainHeader onClick={props.onHeaderClick} isMap={props.isMap} />{" "}
            {!!props.propertiesCount && (
                <Text variant="body_copy_1" css={offerCounterInfo}>
                    {numberFormat(props.propertiesCount)} {propertyOffer.nominative(props.propertiesCount)} w {numberFormat(props.offerCount)}{" "}
                    {investmentOffer.locative(props.offerCount)}
                    {showPromotionsLink && <OfferListPromotionLink selectedRegion={props.selectedRegion} />}
                </Text>
            )}
            {hasRegionAveragePrice && singleRegion ? <OfferAveragePrice singleRegion={singleRegion} css={avgPriceVisibility} /> : null}
        </>
    );
};

const isAnyFilterInUse = (query: ILatestQuery) => {
    return Boolean(
        query.price_1 ||
        query.rooms_0 ||
        query.rooms_1 ||
        query.area_0 ||
        query.area_1 ||
        query.construction_end_date ||
        query.floor_choices ||
        query.house_type ||
        query.house_additional_areas ||
        query.house_storeys
    );
};

const avgPriceVisibility = (theme: Theme) => css`
    ${display("none")};

    @media (min-width: ${theme.breakpoints.md}) {
        ${display("flex")};
    }
`;

const offerCounterInfo = (theme: Theme) => css`
    color: ${theme.colors.gray[700]};

    ${display("none")};

    @media (min-width: ${theme.breakpoints.md}) {
        ${display("block")};
    }
`;
import {css, Theme} from "@emotion/react";

import {display} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {investmentOffer, numberFormat, propertyOffer} from "@pg-mono/string-utils";

import {ILatestQuery} from "../../../../utils/latest_query";
import {ListMainHeader} from "../../../atoms/ListMainHeader";
import {OfferAveragePrice} from "../OfferAveragePrice/OfferAveragePrice";
import {OfferListPromotionLink} from "../OfferListPromotionLink";
import {OfferListHeaderProps} from "./OfferListHeader";

interface IProps extends OfferListHeaderProps {
    onHeaderClick?: () => void;
}

export const OfferListHeaderText = (props: IProps) => {
    const promotionsCount = props.selectedRegion.length === 1 ? props.selectedRegion[0].stats?.promotions_count_total : 0;
    const hidePromotions = isAnyFilterInUse(props.latestQuery);
    // Minimum promotions number needed to display link - business requirement
    const isLessPromotionsThenOffers = !!props.propertiesCount && !!promotionsCount && props.propertiesCount < promotionsCount;
    const showPromotionsLink = !!promotionsCount && promotionsCount > 5 && !isLessPromotionsThenOffers && !hidePromotions;
    const singleRegion = !!props.selectedRegion.length ? props.selectedRegion[props.selectedRegion.length - 1] : undefined;
    const hasRegionAveragePrice = singleRegion?.stats?.average_price_m2;

    return (
        <>
            <ListMainHeader onClick={props.onHeaderClick} isMap={props.isMap} />{" "}
            {!!props.propertiesCount && (
                <Text variant="body_copy_1" css={offerCounterInfo}>
                    {numberFormat(props.propertiesCount)} {propertyOffer.nominative(props.propertiesCount)} w {numberFormat(props.offerCount)}{" "}
                    {investmentOffer.locative(props.offerCount)}
                    {showPromotionsLink && <OfferListPromotionLink selectedRegion={props.selectedRegion} />}
                </Text>
            )}
            {hasRegionAveragePrice && singleRegion ? <OfferAveragePrice singleRegion={singleRegion} css={avgPriceVisibility} /> : null}
        </>
    );
};

const isAnyFilterInUse = (query: ILatestQuery) => {
    return Boolean(
        query.price_1 ||
        query.rooms_0 ||
        query.rooms_1 ||
        query.area_0 ||
        query.area_1 ||
        query.construction_end_date ||
        query.floor_choices ||
        query.house_type ||
        query.house_additional_areas ||
        query.house_storeys
    );
};

const avgPriceVisibility = (theme: Theme) => css`
    ${display("none")};

    @media (min-width: ${theme.breakpoints.md}) {
        ${display("flex")};
    }
`;

const offerCounterInfo = (theme: Theme) => css`
    color: ${theme.colors.gray[700]};

    ${display("none")};

    @media (min-width: ${theme.breakpoints.md}) {
        ${display("block")};
    }
`;
